<template>
  <div>
    <div class="p-3 bg-white rounded-xl shadow-lg mx-4">
      <div class="grid grid-cols-2" @click="showFilters = !showFilters">
        <div class="flex items-center gap-4">
          <a-icon type="filter" class="text-lg ml-2"></a-icon>
          <h2 class="text-left text-lg text-gray-600">
            <b>Filtros de búsqueda</b>
          </h2>
        </div>
        <span
          class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
          :class="{ 'transform rotate-180': showFilters }"
        >
          <a-icon type="caret-down" class="text-xl my-auto" />
        </span>
      </div>
      <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
      <div
        class="flex gap-5 flex-wrap relative w-full border-box"
        v-show="showFilters"
      >
        <form id="filterSupportForm" @submit.prevent="submitForm">
          <div
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
          >
            <!--Código de quejas -->
            <BaseInput
              type="text"
              label="Código de queja"
              placeholder="Ej: 26598965472981"
              v-model="form.codigo_queja"
            />

            <!--Motivo -->
            <BaseSelect
              ref="motivo_agiliza"
              id="motivo_agiliza"
              label="Motivo agiliza"
              :selectOptions="formOptions.optionsReasonsAgiliza"
              v-model="form.motivo_agiliza_cod"
              :value="form.motivo_agiliza_cod"
              :loading="loading"
            />

            <template v-if="activeKey === '1'">
              <!--Estado de radicación -->
              <BaseSelect
                ref="estado_agiliza"
                id="estado_agiliza"
                label="Estado agiliza"
                :selectOptions="formOptions.optionsStatesAgilizaEv"
                v-model="form.estado_agiliza_id"
                :value="form.estado_agiliza_id"
                :loading="loading"
              />
            </template>

            <template v-if="activeKey === '2' || activeKey === '3'">
                     <!-- Fecha de sesión. -->
              <BaseRangeDate
                ref="fecha_de_sesion"
                label="Fecha de sesión"
                :value="
                  form.session_start && form.session_end
                    ? [form.session_start, form.session_end]
                    : null
                "
                @notify-dates="setRangeDateSession($event)"
              />
              
              <BaseMultiSelect
                :valuesSelected="void_array"
                title="Estado de la sesión"
                :data="customStatesSessions"
                label="name"
                @notify-objects="setMultiSelect($event)"
              />
       
            </template>

            <!--Tipo de identificación -->
            <BaseSelect
              ref="tipo_documento"
              id="tipo_documento"
              label="Tipo de identificación"
              :selectOptions="formOptions.optionsIdentificationType"
              v-model="form.tipo_id_CF"
              :value="form.tipo_id_CF"
              :loading="loading"
            />

            <!--Número de identificación -->
            <BaseNumber
              label="No. de identificación"
              placeholder="Ej: 123456789"
              v-model="form.numero_id_CF"
              :doNotValidateNit="true"
            />

            <!-- Fecha de radicacion. -->
            <BaseRangeDate
              ref="fecha_de_creacion"
              label="Fecha de creación"
              :value="
                form.start_date && form.end_date
                  ? [form.start_date, form.end_date]
                  : null
              "
              @notify-dates="setRangeDate($event)"
            />
          </div>

          <div class="w-full flex justify-end self-end gap-4 mt-5 mb-3">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="primary"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>

            <!-- :disabled="disableButton && disabled" -->
            <!-- :loading="(searching = loading)"  -->
            <a-button
              :disabled="searching ? true : false"
              type="primary"
              shape="round"
              @click="submitForm"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "@/core/utils/constants";

export default {
  props: {
    activeKey: {
      type: String,
      default: "1",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    searching: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        nombres: "",
        company_emisores_id: "",
        motivo_emisores_id__tipo_valor_id: "",
        motivo_agiliza_cod: "",
        codigo_queja: "",
        tipo_id_CF: "",
        numero_id_CF: "",
        apoderado_nombre: "",
        apoderado_correo: "",
        start_date: "",
        end_date: "",
        estado_agiliza_id: "",
        estado_solip_anexes: "",
        motivo_agiliza_cod: "",
        session_state_agiliza: [],
        session_start: "",
        session_end: "",
      },
      optionsReasonsEmisor: [],
      showFilters: false,
      void_array: [],
    };
  },
  created() {
    this.initializeForm();
  },
  async mounted() {
    const pagination = {};
    this.$emit("getFilterForm", this.form, pagination);
  },
  methods: {
    async submitForm() {
      const formToSubmit = {
        ...this.form,
        agiliza_estado_sesion: Array.isArray(this.form.session_state_agiliza)
          ? this.form.session_state_agiliza.join(",")
          : this.form.session_state_agiliza,
      };

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", formToSubmit, pagination);
    },
    async clearFilters() {
      this.initializeForm();

      const pagination = {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
      };

      this.$emit("getFilterForm", this.form, pagination);
    },
    initializeForm() {
      const startDate = moment().subtract(30, "d").format("YYYY-MM-DD");
      const endDate = moment().format("YYYY-MM-DD");
      this.void_array = [];
      this.form = {
        nombres: "",
        company_emisores_id: "",
        motivo_emisores_id__tipo_valor_id: "",
        motivo_agiliza_cod: "",
        codigo_queja: "",
        tipo_id_CF: "",
        numero_id_CF: "",
        apoderado_nombre: "",
        apoderado_correo: "",
        start_date: startDate,
        end_date: endDate,
        estado_agiliza_id: "",
        estado_solip_anexes: "",
        session_state_agiliza: [],
        session_start: "",
        session_end: "",
      };
    },
    setRangeDateSession(eventValue) {
      this.form.session_start = eventValue ? eventValue[0] : "";
      this.form.session_end = eventValue ? eventValue[1] : "";
    },
    setMultiSelect(ev) {
      this.form.session_state_agiliza = ev.map((item) => item.id);
    },
    setRangeDate(eventValue) {
      this.form.start_date = eventValue ? eventValue[0] : "";
      this.form.end_date = eventValue ? eventValue[1] : "";
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    customStatusSolip: function () {
      return this.$store.state.form?.optionsStatesEmisor?.filter(
        (state) =>
          state.name !== "Error en radicación de anexo(s)" &&
          state.name !== "No aplica al radicado",
      );
    },
    customStatusSolipAnexes: function () {
      return this.$store.state.form?.optionsStatesEmisor?.filter(
        (state) =>
          state.name !== "Error en radicación" &&
          state.name !== "No aplica al radicado",
      );
    },
    customStatesSessions: function () {
      return this.$store.state.form?.optionsStatesSessionsEv?.filter(
        (entity) => entity.id !== 0,
      );
    },
  },
  watch: {
    "form.motivo_emisores_id__tipo_valor_id": async function () {
      this.form.motivo_agiliza_cod = "";
      this.optionsReasonsEmisor = [];
      if (this.form.motivo_emisores_id__tipo_valor_id == "") {
        let options = await this.$store.dispatch(
          "form/loadAllReasonsEmisorOptions",
          { type_value_emisor: this.form.motivo_emisores_id__tipo_valor_id },
        );
        this.optionsReasonsEmisor = [...options];
        return;
      }

      let options = await this.$store.dispatch(
        "form/loadReasonsEmisorOptions",
        { type_value_emisor: this.form.motivo_emisores_id__tipo_valor_id },
      );
      this.optionsReasonsEmisor = [...options];
    },
  },
};
</script>

<style>
#filterSupportForm {
  width: 100%;
}
</style>
